import React from 'react';
import {graphql} from "gatsby";
import Layout from "../components/Layout";
import PageHeader from "../components/PageHeader";
import ArticleSingle from "../components/ArticleSingle";
import { SEO } from "../components/seo";


const getRandomArticles = (allArticles, maxItems, otherArticles) => {
    const otherArticlesIds = otherArticles.map(a => a.id)
    const allArticlesWithoutOtherArticles = allArticles.filter(article => !otherArticlesIds.includes(article.node.id))
    // Shuffle the array
    const shuffledArray = allArticlesWithoutOtherArticles.sort(() => Math.random() - 0.5);

    // Get the first `maxItems` from the shuffled array
    return shuffledArray.slice(0, maxItems);
}

const removeNodeFromArticles = (allArticles) => allArticles.map(article => article.node)

const ArticleSinglePage = ({data}) => {
    const {title, author, date, body, mainImage, otherArticles} = data.contentfulArticle;
    const otherArticlesSafe = otherArticles ? otherArticles : []
    const allArticles = data.allContentfulArticle.edges
    const allArticlesFiltered = getRandomArticles(allArticles, 3 - otherArticlesSafe.length, otherArticlesSafe);
    const allArticlesInCorrectFormat = removeNodeFromArticles(allArticlesFiltered)
    const otherArticlesToDisplay = [...allArticlesInCorrectFormat, ...otherArticlesSafe]


    return (
        <Layout>
            <PageHeader title="Artikelen" />
            <ArticleSingle title={title} author={author} date={date} body={body}
                           mainImage={mainImage} otherArticles={otherArticlesToDisplay}/>
        </Layout>
    );
};

export const Head = ({data}) => (
  <SEO pageTitle={data.contentfulArticle.title} />
)


export default ArticleSinglePage;

export const query = graphql`
    query($id: String!, $gemeente: String!) {
        contentfulArticle(id: { eq: $id }) {
            id
            title,
            author,
            date(formatString: "LL", locale: "nl") ,
            body {
                raw
            },
            mainImage {
                gatsbyImageData(width: 100, height: 70, layout: FULL_WIDTH)
            }
            otherArticles {
                id,
                title,
                date,
                mainImage {
                    gatsbyImageData(width: 100, height: 70, layout: FULL_WIDTH)
                }
            }
        },
        allContentfulArticle(filter: {gemeente: {elemMatch: {internalName: {eq: $gemeente}}}, , id: {ne: $id}}) {
            edges {
                node {
                    id
                    title,
                    date(formatString: "LL", locale: "nl") ,
                    mainImage {
                        gatsbyImageData(width: 100, height: 70, layout: FULL_WIDTH)
                    }
                }
            }
        }
    },
    
`
